/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Client from 'fierry/flux/entity/client';

import Level from 'shared/client/url/level';
import State from 'shared/client/url/state';
import Config from 'shared/query/config'

import * as Route from 'shared/client/url/route';
import * as Util from 'shared/client/url/util';


export default new Client ([ State, Config ], class
{
  constructor ([ state, dispatch ], config)
  {
    this.state = state;
    this.config = config;
    this.dispatch = dispatch;

    this.current = this.getCurrentState();
  }


  reconcile ({ history })
  {
    const { id } = history[history.length - 1] || { id: 1 };

    this.dispatch(State.Reconcile, { history, id });
  }


  pushForeground (route, args = {}, context = {})
  {
    this.pushState({ route, args, context, level: Level.Foreground });
  }


  pushBackground (route, args = {}, context = {})
  {
    this.pushState({ route, args, context, level: Level.Background });
  }


  pushArgs (args, context = {})
  {
    this.pushState({ args, context, level: Level.Args });
  }


  pushState ({ args, ...state })
  {
    args = this.__serializeArgs__(args);

    this.dispatch(State.PushState, { args, ...state });
  }


  popForeground ()
  {
    this.dispatch(State.PopState, { level: Level.Foreground });
  }


  getRoute ()
  {
    return this.current.route;
  }


  getArgs ()
  {
    return this.current.args;
  }


  getArg (key, defaultValue = null)
  {
    return this.getArgs()[key] || defaultValue;
  }


  getContextArg (key)
  {
    return this.current.context[key];
  }


  getDefaultState ()
  {
    return Util.getDefaultState();
  }


  getPopCountBefore (level)
  {
    return Util.getPopCountBefore(this.state, level);
  }


  getSessionURL ()
  {
    return Util.getSessionURL(this.state);
  }


  getSessionState ()
  {
    return Util.getSessionState(this.state);
  }


  getCurrentState ()
  {
    const { route, args, ...current } = this.state.permanent[this.state.permanent.length - 1];

    return { ...current, route: this.makeRoute(route), args: this.__deserializeArgs__(args) };
  }


  getStateFromURL ()
  {
    const { route, args, ...state } = Util.getStateFromURL();

    return { ...state, route: this.makeRoute(route), args: this.__deserializeArgs__(args) };
  }


  makeRoute (value)
  {
    return Route.parse(value, this.config.enum)
  }


  __serializeArgs__ (args)
  {
    args = { ...args };

    for (const key in args)
    {
      if (args[key] == null)
      {
        continue;
      }

      if (this.config.url[key])
      {
        args[key] = this.config.url[key].serialize(args[key]);
      }

      args[key] = btoa(args[key]);
    }

    return args;
  }


  __deserializeArgs__ (args)
  {
    args = { ...args };

    for (const key in args)
    {
      if (args[key] == null)
      {
        continue;
      }


      args[key] = atob(args[key]);

      if (this.config.url[key])
      {
        args[key] = this.config.url[key].deserialize(args[key]);
      }
    }

    return args;
  }


  isNavigationBack (history)
  {
    return history[history.length - 1].id <= this.current.id;
  }


  isNavigationForward (history)
  {
    return history[history.length - 1].id > this.current.id;
  }


  isCardToPaneTransition ()
  {
    return false;
  }


  isPaneToCardTransition ()
  {
    return false;
  }


  isPaneToPaneTransition ()
  {
    return false;
  }


  startAnimation ()
  {
    // no-op.
  }


  endAnimation ()
  {
    // no-op.
  }


});
